import { Info } from "lucide-react";

export const TEST_TOKEN_NOTE = "Live FSC ecosystem tokens";

export const TestTokenNote = ({ testId, className = "" }) => (
  <p data-testid={testId} className={`inline-flex items-center gap-1.5 text-xs text-amber-300/90 bg-amber-500/10 border border-amber-500/30 rounded-md px-2.5 py-1 ${className}`}>
    <Info size={12} className="shrink-0" /> {TEST_TOKEN_NOTE}
  </p>
);

export const NetworkDisclosure = ({ testId, className = "" }) => (
  <ul data-testid={testId} className={`text-xs text-zinc-400 space-y-1 list-disc pl-4 ${className}`}>
    <li>FSC currently runs on a single app-hosted node.</li>
    <li>FBTC is not BTC-backed.</li>
    <li>The USDT shown is a test token, not Tether.</li>
  </ul>
);
